export const TRANSLATIONS_ES_SHELL_AND_COMMON = {
  "navbar.brand": "Sistema RAG",
  "nav.home": "Inicio",
  "nav.expandSidebar": "Expandir menú lateral",
  "nav.collapseSidebar": "Contraer menú lateral",
  "nav.notifications": "Notificaciones",
  "nav.userMenu": "Menú de usuario",
  "nav.help": "Ayuda",
  "nav.chat": "Chat",
  "nav.upload": "Subir Documentos",
  "nav.dashboard": "Dashboard",
  "nav.profile": "Perfil",
  "nav.settings": "Preferencias",
  "nav.logout": "Cerrar Sesión",
  "nav.query": "Consulta",
  "nav.about": "Acerca de",
  "nav.tasks": "Tareas",
  "nav.plan": "Plan",
  "plan.tabs.overview": "Mi plan",
  "plan.tabs.detail": "Detalle",
  "nav.usage": "Mi plan",
  "auth.login": "Iniciar Sesión",
  "auth.or": "o",
  "auth.signup": "Registrarse",
  "auth.powered_by": "Desarrollado por",
  " ": "Doble clic para descargar",
  "common.close": "Cerrar",
  "common.options": "Opciones",
  "common.cancel": "Cancelar",
  "nav.documents": "Documentos",
  "notifications.title": "Notificaciones",
  "notifications.markAllRead": "Marcar todas como leídas",
  "header.help": "Ayuda",
  "header.theme.switchToLight": "Cambiar a tema claro",
  "header.theme.switchToDark": "Cambiar a tema oscuro",
  "role.admin": "Administrador",
  "role.user": "Usuario",
  "footer.rights": "Todos los derechos reservados.",
  "footer.terms": "Términos de servicio",
  "footer.privacy": "Política de privacidad",
  "footer.contact": "Contacto",
  "auth.create_account": "Crear cuenta",
  "auth.signup_description": "Crea una cuenta para comenzar",
  "auth.back_to_login": "Volver a iniciar sesión",
  "auth.loading": "Cargando...",
  "auth.redirecting": "Redirigiendo...",
  "nav.admin": "Admin",
  "notifications.empty": "Sin notificaciones",
  "role.executive": "Ejecutivo",
  "common.yes": "Sí",
  "common.no": "No",
  "common.save": "Guardar",
  "common.email": "Email",
  "common.role": "Rol",
  "common.created": "Creado",
  "common.actions": "Acciones",
  "common.page": "Página",
  "common.of": "de",
  "common.prev": "Anterior",
  "common.next": "Siguiente",
  "common.status": "Estado",
  "common.name": "Nombre",
  "common.records": "registros",
  "common.inactive": "Inactivo",
  "common.activate": "Activar",
  "common.deactivate": "Inactivar",
  "common.sending": "Enviando...",
  "errors.email_required": "El email es obligatorio.",
  "errors.email_invalid": "Formato de email inválido.",
  "errors.role_required": "El rol es obligatorio.",
  "breadcrumbs.input.label": "Ubicación del archivo",
  "breadcrumbs.popover.create_option": "Crear carpeta",
  "breadcrumbs.modal.label": "Nombre de la carpeta",
  "breadcrumbs.modal.button.cancel": "Cancelar",
  "breadcrumbs.modal.button.create": "Crear",
  "nav.generate": "Documentos Generados",
  "nav.knowledge": "Conocimiento",
  "nav.changes": "Cambios",
  "nav.alerts": "Alertas",
  "nav.knowledgeHub": "Knowledge Hub",
};
